import * as React from "react";
import Screen from "../../components/screen/Screen";
import {ROUTE_ACTIVITIES} from "../../routing/Routes";
import {FormattedMessage} from "react-intl";

interface Props {

}

export default class ActivitiesScreen extends React.Component<Props> {

    public render(): React.ReactNode {

        return (
            <Screen currentRoute={ROUTE_ACTIVITIES}>
                <div className={"section-container"}>
                    <h2><FormattedMessage id={'activities.title'}/></h2>

                    <div className={"content"}>

                        <h3><FormattedMessage id={'municipal-school.title'}/></h3>
                        <FormattedMessage id={'municipal-school.description'}/>

                        <h3><FormattedMessage id={'introductory-course.title'}/></h3>
                        <FormattedMessage id={'introductory-course.description'}/>

                        <h3><FormattedMessage id={'adapted-bow.title'}/></h3>
                        <FormattedMessage id={'adapted-bow.description'}/>

                        <h3><FormattedMessage id={'sports-animation.title'}/></h3>
                        <FormattedMessage id={'sports-animation.description'}/>

                        <h3><FormattedMessage id={'historial-reenactment.title'}/></h3>
                        <FormattedMessage id={'historial-reenactment.description'}/>

                    </div>
                </div>
            </Screen>
        )
    }
}